var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultOfficialAccountDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3B4052"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29610_32262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64014 15.2301L23.9995 6.24023L39.3601 15.2288L23.997 24.258L8.64014 15.2301Z",
    fill: "#2E3343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.997 24.2584L8.64014 15.2305V33.1924L23.997 42.2406V24.2584Z",
    fill: "#2A2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.997 24.2584L8.64014 15.2305V33.1924L23.997 24.2584Z",
    fill: "#353A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 24.2584L39.3564 15.2305V33.1924L23.9971 42.2406L23.9996 24.2584Z",
    fill: "#2A2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 24.2584L39.3564 15.2305V33.1924L23.9995 24.2584Z",
    fill: "#575D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4004 19.2045L23.9971 14.1729L32.6525 19.2388L23.9946 24.3288L15.4004 19.2045Z",
    fill: "#2A2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9971 24.2583L15.4004 19.2051V31.6819L20.424 34.4994L23.9971 32.3881V24.2583Z",
    fill: "#575D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.997 30.4913L20.4302 28.4678V34.4762L23.997 32.3879V30.4913Z",
    fill: "#353A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9956 24.2583L32.5911 19.2051V31.6819L27.5687 34.4994L23.9956 32.3881V24.2583Z",
    fill: "#353A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9956 30.4913L27.5625 28.4678V34.4762L23.9956 32.3879V30.4913Z",
    fill: "#575D70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29610_32262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.72,
    height: 36,
    fill: "white",
    transform: "translate(8.64014 6.24023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOfficialAccountDark);
export default __webpack_public_path__ + "static/media/default-official-account-dark.d358c9939a3b625a394c938cdb9cbb95.svg";
export { ForwardRef as ReactComponent };